import { createAction, props } from '@ngrx/store';
import {
  OnboardingFilters,
  OnboardingLoadParams,
  OnboardingManagementView,
  STORE_TYPE,
} from './advisor-onboarding.model';

// Load onboardings actions
export const loadOnboardings = createAction(
  `${STORE_TYPE} Load Onboardings`,
  props<{ params?: OnboardingLoadParams }>(),
);

export const loadOnboardingsSuccess = createAction(
  `${STORE_TYPE} Load Onboardings (Success)`,
  props<{
    onboardings: OnboardingManagementView[];
    totalCount: number;
    currentPage: number;
  }>(),
);

export const loadOnboardingsFailure = createAction(
  `${STORE_TYPE} Load Onboardings (Failure)`,
  props<{ error: string }>(),
);

// Filter actions
export const setFilter = createAction(
  `${STORE_TYPE} Set Filters`,
  props<{ filter: Partial<OnboardingFilters> }>(),
);

export const resetFilter = createAction(`${STORE_TYPE} Reset Filters`);

export const updatePagination = createAction(
  `${STORE_TYPE} Update Pagination`,
  props<{ page: number; pageSize: number }>(),
);

// Clear state action
export const clearOnboardings = createAction(`${STORE_TYPE} Clear Onboardings`);
